import React, { useContext, useRef, useState } from "react";
import { NavLink, useLocation } from 'react-router-dom';
import DebugLogger from '../../helpers/DebugLogger';
import  { NAV_AREAS, TOP_LEVEL_NAV_ROUTES } from "../../config/NavRoutes";

import "./Navbar.scss";
import { AuthContext } from "../../contexts/AuthContext";
import { ACCOUNT_TYPES } from "../../helpers/AccountTypes";
import LottieIcon from "../common/LottieIcon";
import HomeIcon from "../../assets/Home.json";
import CampaignIcon from "../../assets/Campaigns.json";
import QuizzesIcon from "../../assets/Quizzes.json";
import UsersIcon from "../../assets/Users.json";
import AnalyticsIcon from "../../assets/Analytics.json";
import ScheduleIcon from "../../assets/Schedule.json";
import BugsIcon from "../../assets/Bugs.json";
import SiteAdminIcon from "../../assets/SiteAdmin.json";
import DebugIcon from "../../assets/Debug.json";

const NavBar = () => {
    const location = useLocation();
    // DebugLogger.log('Nav path: ' + location.pathname);
    const [authContext, setAuthContext] = useContext(AuthContext);

    const [expanded, setExpanded] = useState(false);
    const toggleExpanded = () => setExpanded(!expanded);

    const homeRef = useRef(null);
    const campaignsRef = useRef(null);
    const quizzesRef = useRef(null);
    const usersRef = useRef(null);
    const analyticsRef = useRef(null);
    const scheduleRef = useRef(null);
    const bugsRef = useRef(null);
    const siteAdminRef = useRef(null);
    const debugRef = useRef(null);

    return (
        <nav className={'nav-bar-container ' + (expanded ? 'nav-expanded' : 'nav-collapsed')}>
            {/* <div className="nav-bar-section nav-expander-container">
                <div onClick={toggleExpanded} className="cursor-pointer">{IconJsxer.GetIcon(expanded ? IconJsxer.ICONS.chevronLeft : IconJsxer.ICONS.chevronRight, IconJsxer.ICON_STYLES.nav)}<span className="nav-bar-text">Collapse</span></div>
            </div> */}
            <div className="nav-bar-top-section-spacer"></div>
            <div className={'nav-bar-section nav-' + (location.pathname.split('/')[1] === NAV_AREAS.HOME ? '' : 'in') + 'active'}>
                <NavLink to={TOP_LEVEL_NAV_ROUTES.HOME}>
                    <div className="nav-link-content" ref={homeRef}>
                        <LottieIcon icon={HomeIcon} size={32} triggerRef={homeRef} />
                        <span className="nav-bar-text">Home</span>
                    </div>
                </NavLink>
            </div>
            <div className={'nav-bar-section nav-' + (location.pathname.split('/')[1] === NAV_AREAS.CAMPAIGNS ? '' : 'in') + 'active'}>
                <NavLink to={TOP_LEVEL_NAV_ROUTES.CAMPAIGNS}>
                    <div className="nav-link-content" ref={campaignsRef}>
                        <LottieIcon icon={CampaignIcon} size={32} triggerRef={campaignsRef} />
                        <span className="nav-bar-text">Campaigns</span>
                    </div>
                </NavLink>
            </div>
            {authContext.userData.userLevel >= ACCOUNT_TYPES.creative.level &&
                <div className={'nav-bar-section nav-' + (location.pathname.split('/')[1] === NAV_AREAS.QUIZZES ? '' : 'in') + 'active'}>
                    <NavLink to={TOP_LEVEL_NAV_ROUTES.QUIZZES}>
                    <div className="nav-link-content" ref={quizzesRef}>
                            <LottieIcon icon={QuizzesIcon} size={32} triggerRef={quizzesRef} />
                            <span className="nav-bar-text">Quizzes</span>
                        </div>
                    </NavLink>
                </div>
            }
            {authContext.userData.userLevel >= ACCOUNT_TYPES.producer.level &&
                <div className={'nav-bar-section nav-' + (location.pathname.split('/')[1] === NAV_AREAS.USERS ? '' : 'in') + 'active'}>
                    <NavLink to={TOP_LEVEL_NAV_ROUTES.USERS}>
                        <div className="nav-link-content" ref={usersRef}>
                        <LottieIcon icon={UsersIcon} size={32} triggerRef={usersRef} />
                        <span className="nav-bar-text">Users</span>
                        </div>
                    </NavLink>
                </div>
            }
            {authContext.userData.userLevel >= ACCOUNT_TYPES.producer.level &&
                <div className={'nav-bar-section nav-' + (location.pathname.split('/')[1] === NAV_AREAS.ANALYTICS ? '' : 'in') + 'active'}>
                    <NavLink to={TOP_LEVEL_NAV_ROUTES.ANALYTICS}>
                        <div className="nav-link-content" ref={analyticsRef}>
                        <LottieIcon icon={AnalyticsIcon} size={32} triggerRef={analyticsRef} />
                        <span className="nav-bar-text">Analytics</span>
                        </div>
                    </NavLink>
                </div>
            }   
            {authContext.userData.userLevel >= ACCOUNT_TYPES.producer.level &&    
                <div className={'nav-bar-section nav-' + (location.pathname.split('/')[1] === NAV_AREAS.SCHEDULE ? '' : 'in') + 'active'}>
                    <NavLink to={TOP_LEVEL_NAV_ROUTES.SCHEDULE}>
                        <div className="nav-link-content" ref={scheduleRef}>
                        <LottieIcon icon={ScheduleIcon} size={32} triggerRef={scheduleRef} />
                        <span className="nav-bar-text">Schedule</span>
                        </div>
                    </NavLink>
                </div>
            }
            { authContext.userData.userLevel >= ACCOUNT_TYPES.twitchSuperUser.level &&
                <div className={'nav-bar-section nav-' + (location.pathname.split('/')[1] === NAV_AREAS.BUG_REPORTS ? '' : 'in') + 'active'}>
                    <NavLink to={TOP_LEVEL_NAV_ROUTES.BUG_REPORTS}>
                        <div className="nav-link-content" ref={bugsRef}>
                            <LottieIcon icon={BugsIcon} size={32} triggerRef={bugsRef} />
                            <span className="nav-bar-text">Bug Reports</span>
                        </div>
                    </NavLink>
                </div>
            }
            { authContext.userData.userLevel >= ACCOUNT_TYPES.twitchSuperUser.level &&
                <div className={'nav-bar-section nav-' + (location.pathname.split('/')[1] === NAV_AREAS.SITE_ADMIN ? '' : 'in') + 'active'}>
                    <NavLink to={TOP_LEVEL_NAV_ROUTES.SITE_ADMIN}>
                        <div className="nav-link-content" ref={siteAdminRef}>
                            <LottieIcon icon={SiteAdminIcon} size={32} triggerRef={siteAdminRef} />
                            <span className="nav-bar-text">Site Admin</span>
                        </div>
                    </NavLink>
                </div>
            }
            { authContext.userData.userLevel >= ACCOUNT_TYPES.koko.level &&
                <div className={'nav-bar-section nav-' + (location.pathname.split('/')[1].indexOf(NAV_AREAS.DEBUG) >= 0 ? '' : 'in') + 'active'}>
                    <NavLink to={TOP_LEVEL_NAV_ROUTES.KOKO_DEBUG_TOOLS}>
                        <div className="nav-link-content" ref={debugRef}>
                            <LottieIcon icon={DebugIcon} size={32} triggerRef={debugRef} />
                            <span className="nav-bar-text">Koko Debug</span>
                        </div>
                    </NavLink>
                </div>
            }
            <div className="nav-bar-bottom-section-spacer"></div>
        </nav>
    );
}

export default NavBar;
